import React, { useState, useEffect, useCallback } from "react";
import { Box, Typography, Link } from "@mui/material";
import Grid from "@mui/material/Grid";
import Input from "../Common/Components/InputField";
import ErrorMessage from "../Common/Components/ErrorMessage";
import { useForm } from "react-hook-form";
import ActionButton from "../Common/Components/Button";
import { useTranslation } from "react-i18next";
import BubbleImg from "../assets/bubbles.svg";
import Loading from "../Common/Components/Loading";
import { ShowAlert } from "../Common/Components/Alert";
import service from "../apiSection/service";
import { login, verifyUser } from "../apiSection/apiUrlConstent";
import { useDispatch } from "react-redux";
import { loginauth } from "../Common/ReduxStore/UserStore";
import { addCookies } from "../apiSection/util";
import { debounce } from "lodash";
import SetPassword from "./SetPassword";
import { useSelector } from "react-redux";

export default function LoginScreen(props) {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation("common");
  const [loginData, setLoginData] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [tempUserData, setTempUserData] = useState(null);
  const token=useSelector((store)=>store.auth.token);
  const {
    register,
    handleSubmit : reactHookFormHandleSubmit,

    setError,
    clearErrors,
    formState: { errors },
  } = useForm();
  const hanldeshowPassword = (data) => {
    setShowPassword(data);
  };
  const handleLogin = (data) => {
    setLoading(true);
    const postData = {
      user_login: data.receiveremailaddress,
      password: data.password,
    };
  
    service
      .create(login, postData)
      .then((res) => {
        const result = res?.data?.result; // ✅ safely extract
  
        if (!result) {
          setLoading(false);
          ShowAlert({
            icon: "error",
            text: res?.data?.message || "Unexpected response from server",
            width: "400px",
          });
          return;
        }
  
        // Handle language change safely
        if (i18n && i18n.changeLanguage) {
          switch (result.state_id) {
            case 1:
              i18n.changeLanguage("guj").catch((err) =>
                console.error("Error switching to Gujarati:", err)
              );
              break;
            case 2:
              i18n.changeLanguage("tam").catch((err) =>
                console.error("Error switching to Tamil:", err)
              );
              break;
            case 3:
              i18n.changeLanguage("tri").catch((err) =>
                console.error("Error switching to Tripura:", err)
              );
              break;
            case 4:
              i18n.changeLanguage("miz").catch((err) =>
                console.error("Error switching to Mizoram:", err)
              );
              break;
            default:
              i18n.changeLanguage("en").catch((err) =>
                console.error("Error switching to English:", err)
              );
              break;
          }
        }
  
        setLoading(false);
  
        if (result.is_password_updated === 0) {
          setTempUserData(result);
          setShowNewPassword(true);
        } else {
          dispatch(loginauth(result));
          localStorage.setItem("userId", result.role_id);
          addCookies(result.token);
          props.Redirectpath("/dashboard");
        }
      })
      .catch((error) => {
        setLoading(false);
  
        const errorMsg =
          error?.response?.data?.message || "Something went wrong";
  
        ShowAlert({
          icon: "error",
          text: errorMsg,
          width: "400px",
        });
      });
  };
  

  const handleVerifyUser = (data) => {
    setLoading(true);
    const postData = {
      user_login: data.receiveremailaddress,
    };

    service
  .create(verifyUser, postData)
  .then((res) => {
    setLoading(false);

    // Adjust depending on backend response structure
    const message = res?.data?.message || res?.message;

    if (message) {
      setError("receiveremailaddress", {
        type: "verify",
        message: message,
      });
    } else {
      clearErrors("receiveremailaddress");
    }
  })
  .catch((error) => {
    setLoading(false);
    setError("receiveremailaddress", {
      type: "verify",
      message: error.response?.data?.message || "User does not exist",
    });
  });

  };
  const debouncedHandleVerifyUser = useCallback(
    debounce(handleVerifyUser, 3000),
    []
  );

  const handleForgetPasswordRedirect = () => {
    props.Redirectpath("/ForgotPassword");
  };
  
  const handleKeyPressPassword = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      reactHookFormHandleSubmit(handleLogin)();
    }
  };

  

  return (
    <Grid container sx={{ height: "100vh" }}>
      <Loading open={loading} />
      {/* Left Section */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          background: "linear-gradient(180deg, #FFFFFF 0%, #0FA5D9 100%);",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 4,
        }}
      >
        <Box textAlign="center">
          <div>
            <img src={BubbleImg} width="100%" />
          </div>
          <Typography
            color="#FFFFFF"
            sx={{
              fontStyle: "italic",
              fontFamily: "Poppins",
              fontSize: "40px",
            }}
          >
            AI-POWERED
          </Typography>
          <Typography
            color="#000080"
            sx={{
              mt: 2,
              fontStyle: "italic",
              fontFamily: "Poppins",
              fontSize: "36px",
            }}
          >
            Help Desk
          </Typography>
        </Box>
      </Grid>

      {/* Right Section */}
      {(showNewPassword && tempUserData && tempUserData.token )? (
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 4,
            bgcolor: "#fff",
          }}
        >
          <Box sx={{ width: "100%", maxWidth: 400 }}>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", color: "#3399FF" }}
            >
              Ticketing Tool
            </Typography>
            <Typography
              sx={{
                fontWeight: "bold",
                color: "red",
                fontSize: "20px",
                mt: 0.5,
              }}
            >
              TEST ENVIRONMENT
            </Typography>
            <Typography color="#4B5563" sx={{ mt: 1 }}>
              Please Update your Password to log in to the application.
            </Typography>

            {/* Form */}
            <Box component="form" noValidate sx={{ mt: 4 }}>
              <SetPassword Redirectpath={props.Redirectpath} userData={tempUserData} loaded_from="LOGIN" />
            </Box>
          </Box>
        </Grid>
      ) : (
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 4,
            bgcolor: "#fff",
          }}
        >
          <Box sx={{ width: "100%", maxWidth: 400 }}>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", color: "#3399FF" }}
            >
              Ticketing Tool
            </Typography>
            <Typography
              sx={{
                fontWeight: "bold",
                color: "red",
                fontSize: "20px",
                mt: 0.5,
              }}
            >
              TEST ENVIRONMENT
            </Typography>
            <Typography color="#4B5563" sx={{ mt: 1 }}>
              Please enter your credentials to log in to the application.
            </Typography>

            {/* Form */}
            <Box component="form"  sx={{ mt: 4 }}>
              <div style={{ padding: "10px 0px" }}>
                <Input
                  name="receiveremailaddress"
                  type="text"
                  id="receiveremailaddress"
                  label="PAC’S ID / Email Address / Mobile Number"
                  borderRadius="8px"
                  backgroundColor="white"
                  color="#707EAE"
                  placeholder="PAC’S ID / Email Address / Mobile Number"
                  required={true}
                  handleKeyPress={handleKeyPressPassword}
                  inputRef={register("receiveremailaddress", {
                    required: true,
                    onChange: (e) => {
                      debouncedHandleVerifyUser({
                        receiveremailaddress: e.target.value,
                      });
                    },
                    // pattern: {
                    //   value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                    //   message: "Invalid email address",
                    // },
                  })}
                />
                <div>
                  {errors.receiveremailaddress &&
                    errors.receiveremailaddress.type === "required" && (
                      <ErrorMessage message="Email is Required !!" />
                    )}
                  {errors.receiveremailaddress && (
                    <ErrorMessage
                      message={errors.receiveremailaddress.message}
                    />
                  )}
                </div>
              </div>
              <div style={{ padding: "10px 0px" }}>
                <Input
                  name="password"
                  label="Password"
                  id="password"
                  borderRadius="8px"
                  placeholder="***********"
                  border="none"
                  type={showPassword ? "text" : "password"}
                  visibilityIcon
                  required={true}
                  backgroundColor="#000024"
                  hanldeshowPassword={hanldeshowPassword}
                  visibilityIconColor="#0FA5D8"
                  visibilityIconFont="17px"
                  handleKeyPress={handleKeyPressPassword}
                  inputRef={register("password", {
                    required: true,
                  })}
                />
              </div>
              <div>
                {errors.password && errors.password.type === "required" && (
                  <ErrorMessage message="Required !!" />
                )}
              </div>
              <div>
                {errors.password && (
                  <ErrorMessage message={errors.password.message} />
                )}
              </div>
              <Link
                sx={{
                  display: "block",
                  mt: 1,
                  color: "#2B3674",
                  cursor: "pointer",
                }}
                onClick={handleForgetPasswordRedirect}
              >
                Forgot Password
              </Link>

              <div style={{ padding: "15px 0px" }}>
                <ActionButton
                  backgroundColor="#3399FF"
                  color="white"
                  fullWidth={true}
                  buttonText="Login"
                  handleSubmit={reactHookFormHandleSubmit(handleLogin)}
                />
              </div>
            </Box>

            <Typography
              variant="body2"
              color="textSecondary"
              align="center"
              sx={{ mt: 4 }}
            >
              ©2024 Powered by Machint Solutions Ltd <a href="https://www.machint.com/privacy-policy.html" target="_blank">Privacy Policy</a>
              
            </Typography>
          </Box>
        </Grid>
      )}
    </Grid>
  );
}